import urls from '../api_urls/push'
import { _post } from '@/axios/request'

// 获取订阅列表
export function getPushList (params) {
  return _post(urls.GET_PUSH_LIST, params)
}

// 获取auto订阅列表
export function getAutoPushList (params) {
  return _post(urls.GET_AUTO_PUSH_LIST, params)
}

// 保存订阅
export function savePush (params) {
  return _post(urls.SAVE_PUSH, params)
}

// 编辑订阅
export function editPush (params) {
  return _post(urls.EDIT_PUSH, params)
}

// 删除订阅
export function deletePush (params) {
  return _post(urls.DELETE_PUSH, params)
}

// 获取订阅详情
export function findPush (params) {
  return _post(urls.FIND_PUSH, params)
}

// 查看统计信息
export function findStatistics (params) {
  return _post(urls.FIND_STATISTICS, params)
}

// 撤销订阅
export function recall (params) {
  return _post(urls.RECALL, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/push.js